<template>
  <div class="page">
    <div class="split-layout">
      <!-- Payment Form Section -->
      <div class="form-section">
        <div class="area">
          <form action="">
            <div class="form-floating mb-3">
              <input type="number" step="0.01" class="form-control" @input="setSplitTotal"
                     v-model.number="splitArray.cash" id="splitCash"
                     >
              <label for="splitCash">Cash Amount</label>
            </div>

            <div class="form-floating mb-3">
              <input type="number" step="0.01" class="form-control" @input="setSplitTotal"
                     v-model.number="splitArray.card" id="splitCard"
                     >
              <label for="splitCard">Card Amount</label>
            </div>


            <div class="form-floating mb-3" v-if="isValidString(loyaltyDetails.barcode)">
              <input type="number" step="0.01" class="form-control" @input="setSplitTotal"
                     v-model.number="splitArray[`Loyalty Program`]" id="splitLoyalty"
                     placeholder="Loyalty">
              <label for="splitLoyalty">Loyalty Amount</label>
            </div>

            <div class="form-floating mb-3" v-for="method in splitArray.other">
              <input type="number" step="0.01" class="form-control" @input="setSplitTotal"
                     v-model.number="method.amount" :id="method.id+`-amount`"
                     >
              <label :for="method.id+`-total`"> {{ method.name }} Amount </label>
            </div>

            <div class="form-floating mb-3" v-if="!Number(splitArray.Spenn > 0)">
              <input type="number" step="0.01" class="form-control" @input="setSplitTotal"
                     v-model.number="splitArray.Kazang" id="splitKazang"
                     placeholder="Kazang">
              <label for="splitKazang">Kazang Amount</label>
            </div>
          </form>
        </div>
      </div>

      <!-- Summary Section -->
      <div class="summary-section">
        <div class="summary-card">
          <h5 class="summary-title">Payment Summary</h5>
          
          <div class="summary-item">
            <span class="summary-label">Sale Total:</span>
            <span class="summary-value">{{ $utils.formatMoney(saleTotal - discount.total) }}</span>
          </div>
          
          <div class="summary-item">
            <span class="summary-label">Your Total:</span>
            <span class="summary-value">{{ $utils.formatMoney(splitTotalAmount) }}</span>
          </div>
          
          <div class="summary-item amount-left">
            <span class="summary-label">Amount Left:</span>
            <span class="summary-value" :class="{'amount-valid': !isNotValidSplitTotal, 'amount-invalid': isNotValidSplitTotal}">
              {{ $utils.formatMoney(amountLeft) }}
            </span>
          </div>

          <div class="submit">
            <button :disabled="isNotValidSplitTotal || loading" @click="processSplit"
                    class="submit-btn lyt-soft-btn">
              <span v-if="loading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SplitPaymentScreen",
  beforeMount() {
    const isRefund = Boolean(this.saleDetails?.refund);
    if (this.$store.getters.getHasLoyalty) {
      this.splitArray[`Loyalty Program`] = 0;
    }
    this.splitArray.other = this.$store.getters.getPaymentMethods
        .filter(method => method.active)
        .filter(method => method.IsBaseCurrency)
        .filter(method => !(isRefund && this.isSlipMethod(method?.name)))
        .map(method => {
          method.amount = 0;
          return method;
        });
  },
  data() {
    return {
      loading: false,
      splitTotalAmount: 0,
      splitArray: {
        cash: 0.00,
        card: 0.00,
        Kazang: 0.0,
        Spenn: 0.0,
        other: []
      }
    }
  },
  computed: {
    saleDetails() {
      return this.$store.getters.getSaleDetails || {};
    },
    has543() {
      return this.$store.getters.getHas543;
    },
    loyaltyDetails() {
      return this.$store.getters.getLoyaltyDetails;
    },

    hasKazang() {
      return this.$store.getters.getHasKazang;
    },
    discount() {
      return this.$store.getters.getSaleDiscount;
    },
    saleTotal() {
      return this.$store.getters.getSaleTotal + this.$store.getters.getTipAmount
    },
    isNotValidSplitTotal() {
      return parseFloat(this.amountLeft.toFixed(2)) > 0;
    },
    color() {
      return this.isNotValidSplitTotal ? {color: 'red'} : {color: 'green'}
    },

    disabled() {
      return this.isNotValidSplitTotal ? {background: '#9e9e9e', 'pointer-events': 'none'} : {}
    },

    amountLeft() {
      return parseFloat(this.saleTotal) - parseFloat(this.discount.total) - this.splitTotalAmount;
    },
  },
  methods: {
    isSlipMethod(type) {
      return /slip/i.test(String(type || ''));
    },
    processSplit() {
      if (this.isNotValidSplitTotal || this.loading) return;
      this.openCashDrawer();
      const current = this.saleDetails || {};
      let obj = { ...current };
      this.splitArray.cash = Number(this.splitArray.cash)
      this.splitArray.card = Number(this.splitArray.card)
      this.splitArray.Kazang = Number(this.splitArray.Kazang)
      this.splitArray.Spenn = Number(this.splitArray.Spenn)
      if (this.$store.getters.getHasLoyalty) {
        this.splitArray[`Loyalty Program`] = Number(this.splitArray[`Loyalty Program`])
      }
      this.splitArray.other = this.splitArray.other.map(method => {
        method.amount = Number(method.amount);
        return method;
      });
      obj.splitArray = this.splitArray;
      
      // Ensure total is set for offline processing
      obj.total = parseFloat(this.saleTotal.toFixed(2));
      obj.refund = Boolean(current.refund);

      if (Number(this.splitArray.Kazang) > 0) {
        return this.splitWithKazang(obj)
      } else if (Number(this.splitArray.Spenn) > 0) {
        return this.splitWithSpenn(obj)
      }

      return this.$store.dispatch("processTransaction", obj)
          .then((res) => {
            // Routing is handled by processTransaction action based on hideNextSale setting
          })
    },
    async openCashDrawer() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `OpenDrwer`);
      let isAndroid = androidMode;
      if (!isAllowed || isAndroid) return;
      return this.$store.dispatch(`openCashDrawer`)
    },
    isValidString(string) {
      return isValidString(string);
    },
    setSplitTotal() {
      let total = (
          Number(this.splitArray.cash) +
          Number(this.splitArray.card) +
          Number(this.splitArray.Kazang) +
          Number(this.splitArray.Spenn)
      )
      for (let i = 0; i < this.splitArray.other.length; i++) {
        total += Number(this.splitArray.other[i].amount)
      }
      if (this.$store.getters.getHasLoyalty) {
        total += Number(this.splitArray[`Loyalty Program`]);
      }

      this.splitTotalAmount = total;
    },


    splitWithKazang(obj) {
      // Ensure saleDetails has the correct sale total before initiating Kazang payment
      const updated = {
        ...obj,
        refund: Boolean(obj?.refund),
        total: parseFloat(this.saleTotal.toFixed(2)),
      };
      this.$store.commit('setSaleDetails', updated);

      return Swal.fire({
        title: 'Customer Phone No. ?',
        icon: 'question',
        input: 'tel',
        showCancelButton: true,
        confirmButtonText: 'Process',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: (input) => {
          if (!input) return Swal.showValidationMessage(`Customer Phone No.`);
          updated.customerContact = input;
          return this.$store.dispatch('firstKazangPaymentStep', updated)
              .then((res) => {
                if (res.Error) throw new Error(res.Error);
                else return res;
              }).catch(err => Swal.showValidationMessage(err))
        },
      }).then((result) => {
        if (result.isConfirmed) {
          return this.$router.push({name: 'viewPayment'})
        }
      })
    },

    confirmKazangSplitPayment(firstKazangStepResponse) {
      if (firstKazangStepResponse === "processed") {
        return this.$router.push({name: 'viewPayment'})
      }
      return Swal.fire({
        title: 'Confirm Kazang Payment',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Process',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: () => {
          return this.$store.dispatch('secondKazangStep', firstKazangStepResponse)
              .then((res) => {
                if (res.Error) throw new Error(res.Error)
              })
              .catch(err => Swal.showValidationMessage(err))
        },
      }).then((result) => {
        if (result.isConfirmed) {
          return this.$router.push({name: 'viewPayment'})
        }
      })
    },

    splitWithSpenn(obj) {
      return Swal.fire({
        title: 'Customer Phone No. ?',
        icon: 'question',
        input: 'tel',
        showCancelButton: true,
        confirmButtonText: 'Process',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: (input) => {
          if (!input) return Swal.showValidationMessage(`Customer Phone No.`);
          obj.customerContact = input;
          return this.$store.dispatch('firstSpennPaymentStep', obj)
              .then((res) => {
                if (res.Error) throw new Error(res.Error)
                else return res;
              }).catch(err => Swal.showValidationMessage(err))
        },
      }).then((result) => {
        if (result.isConfirmed) {
          return this.confirmSpennSplitPayment(result.value)
        }
      })
    },

    confirmSpennSplitPayment(firstSpennStepResponse) {
      if (firstSpennStepResponse === "processed") {
        return this.$router.push({name: 'viewPayment'})
      }
      return Swal.fire({
        title: 'Confirm Spenn Payment',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Process',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: () => {
          return this.$store.dispatch('secondSpennStep', firstSpennStepResponse)
              .then((res) => {
                if (res.Error) throw new Error(res.Error)
              })
              .catch(err => Swal.showValidationMessage(err))
        },
      }).then((result) => {
        if (result.isConfirmed) {
          return this.$router.push({name: 'viewPayment'})
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.page {
  min-height: 100vh;
  overflow-y: auto;
  padding: 24px 16px;
  font-family: var(--font-family);
  background: var(--bg-gradient);
  color: var(--text-primary);
  transition: var(--transition-speed);
}

.split-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  max-width: 1200px;
  margin: 0 auto;
  align-items: start;
}

.form-section {
  display: flex;
  justify-content: flex-end;
}

.summary-section {
  display: flex;
  justify-content: flex-start;
  position: sticky;
  top: 24px;
}

.area {
  max-width: 480px;
  width: 100%;
  
  form {
    background: var(--card-bg);
    border: var(--card-border);
    border-radius: 12px;
    padding: 24px;
    box-shadow: var(--card-shadow);
    transition: var(--transition-speed);
  }
  
  .form-floating {
    margin-bottom: 16px !important;
    
    .form-control {
      background: var(--bg-primary);
      border: var(--card-border);
      color: var(--text-primary);
      border-radius: 8px;
      font-size: 16px;
      padding: 12px;
      transition: var(--transition-speed);
      
      &:focus {
        border-color: var(--accent-electric-blue);
        box-shadow: 0 0 0 3px rgba(var(--accent-electric-blue-rgb), 0.15);
        background: var(--bg-primary);
      }
      
      &::placeholder {
        color: var(--text-secondary);
      }
    }
    
    label {
      color: var(--text-secondary);
      font-size: 14px;
      transition: var(--transition-speed);
    }
  }
}

.summary-card {
  background: var(--card-bg);
  border: var(--card-border);
  border-radius: 12px;
  padding: 24px;
  box-shadow: var(--card-shadow);
  transition: var(--transition-speed);
  max-width: 480px;
  width: 100%;
  
  .summary-title {
    font-size: 20px;
    font-weight: 700;
    color: var(--text-primary);
    margin: 0 0 24px 0;
    padding-bottom: 16px;
    border-bottom: var(--card-border);
  }
  
  .summary-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid rgba(128, 128, 128, 0.1);
    
    &.amount-left {
      margin-top: 8px;
      padding-top: 16px;
      border-top: 2px solid var(--accent-electric-blue);
      border-bottom: none;
    }
    
    .summary-label {
      font-size: 16px;
      font-weight: 600;
      color: var(--text-secondary);
    }
    
    .summary-value {
      font-size: 18px;
      font-weight: 700;
      color: var(--text-primary);
      
      &.amount-valid {
        color: var(--success);
      }
      
      &.amount-invalid {
        color: var(--danger);
      }
    }
  }
}

.submit {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}

.submit-btn {
  color: var(--primary-button-text);
  font-size: 18px;
  font-weight: 700;
  font-family: var(--font-family);
  border-radius: 12px;
  width: 100%;
  height: 56px;
  border: none;
  transition: all 0.3s ease;
  background: var(--primary-button-bg);
  box-shadow: 0px 2px 8px rgba(var(--accent-electric-blue-rgb), 0.3);
  
  &:hover:not(:disabled) {
    background: var(--primary-button-hover);
    box-shadow: 0px 4px 12px rgba(var(--accent-electric-blue-rgb), 0.4);
    transform: translateY(-1px);
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  
  &:disabled {
    background: #9e9e9e;
    pointer-events: none;
    opacity: 0.6;
  }
}

// Mobile Responsive Design
@media (max-width: 992px) {
  .split-layout {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  
  .form-section {
    justify-content: center;
  }
  
  .summary-section {
    justify-content: center;
    position: static;
  }
  
  .area,
  .summary-card {
    max-width: 600px;
  }
}

@media (max-width: 768px) {
  .page {
    padding: 16px 12px;
  }
  
  .split-layout {
    gap: 20px;
  }
  
  .area form,
  .summary-card {
    padding: 20px;
  }
  
  .summary-card .summary-title {
    font-size: 18px;
    margin-bottom: 20px;
  }
  
  .summary-card .summary-item {
    .summary-label {
      font-size: 14px;
    }
    
    .summary-value {
      font-size: 16px;
    }
  }
}

@media (max-width: 480px) {
  .page {
    padding: 12px 8px;
  }
  
  .area form,
  .summary-card {
    padding: 16px;
  }
  
  .summary-card .summary-title {
    font-size: 16px;
    margin-bottom: 16px;
    padding-bottom: 12px;
  }
  
  .submit-btn {
    font-size: 16px;
    height: 50px;
  }
}
</style>
